<coso-replicator-page-header [title]="'SharePoint Structure Creator'"></coso-replicator-page-header>
@if (isFailoverBackupInstance) {
<alert type="warning">
  <coso-alert-message>
    This configuration is taken automatically from main instance, and therefore is read-only.
  </coso-alert-message>
</alert>
} @if (successMessage) {
<alert type="success" [dismissible]="true" (onClose)="successMessage = undefined">
  <coso-alert-message>{{ successMessage }}</coso-alert-message>
</alert>
} @if (errorMessage) {
<alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="errorMessage"></div>
  </coso-alert-message>
</alert>
} @if (warningMessage) {
<alert type="warning" [dismissible]="true" (onClose)="warningMessage = undefined">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="warningMessage"></div>
  </coso-alert-message>
</alert>
}

<form [formGroup]="rootFormGroup" (ngSubmit)="saveSettings($event)">
  <div class="row flex-xl-nowrap">
    <div class="col-12 col-md-3 col-xl-2 bd-sidebar">
      <nav class="bd-links" role="navigation" aria-label="SharePoint Structure Creator Navigation">
        <div role="tablist" class="bd-sidenav nav nav-pills flex-column mx-2" aria-orientation="vertical">
          <a role="tab" class="nav-link align-items-center d-flex" routerLink="board" routerLinkActive="active" aria-controls="panel" id="tab-board">
            <span class="fa fa-tachometer mx-2" aria-hidden="true"></span>Board
          </a>
          <a role="tab" class="nav-link align-items-center d-flex" routerLink="general" routerLinkActive="active" aria-controls="panel" id="tab-general">
            <span class="fa fa-cogs mx-2" aria-hidden="true"></span>General
          </a>
          <a role="tab" class="nav-link align-items-center d-flex" routerLink="folder" routerLinkActive="active" aria-controls="panel" id="tab-folder">
            <span class="fa fa-folder mx-2" aria-hidden="true"></span>Folder
          </a>
          <a role="tab" class="nav-link align-items-center d-flex" routerLink="library" routerLinkActive="active" aria-controls="panel" id="tab-library">
            <span class="icon-stack mx-2" aria-hidden="true">
              <i class="fa fa-folder-o" aria-hidden="true"></i>
              <i class="fa fa-file icon-stack-smaller-light" aria-hidden="true"></i>
            </span>
            Library
          </a>
          <a role="tab" class="nav-link align-items-center d-flex" routerLink="site" routerLinkActive="active" aria-controls="panel" id="tab-site">
            <span class="icon-stack mx-2" aria-hidden="true">
              <i class="fa fa-window-maximize" aria-hidden="true"></i>
              <i class="fa fa-globe icon-stack-smaller-light" aria-hidden="true"></i>
            </span>
            Site
          </a>
          <a role="tab" class="nav-link align-items-center d-flex" routerLink="site-collection" routerLinkActive="active" data-toggle="tab" aria-controls="panel" id="tab-site-collection">
            <span class="fa-stack fa-stack-sm mr-1 ml-1" aria-hidden="true">
              <i class="fa fa-square-o fa-stack-2x" aria-hidden="true"></i>
              <i class="fa fa-sitemap fa-stack-1x" aria-hidden="true"></i>
            </span>
            Site collection
          </a>
          <a role="tab" class="nav-link align-items-center d-flex" routerLink="script-editor" routerLinkActive="active" data-toggle="tab" aria-controls="panel" id="tab-script-editor">
            <span class="fa fa-code mx-2" aria-hidden="true"></span>Script editor
          </a>
        </div>
      </nav>
    </div>

    <div class="col-12 col-md-9 col-xl-10 pl-md-5 bd-content" id="panel" role="tabpanel" tabindex="0">
      <router-outlet (activate)="onRouterActivated($event)"></router-outlet>
    </div>
  </div>

  <div class="bd-buttons d-lg-flex justify-content-lg-between align-items-lg-center">
    <div class="col-12 col-lg-4 p-0">
      <button role="link" type="button" class="btn btn-secondary w-md-100" [routerLink]="['/', 'configuration']" id="backButton">
        <span class="fa fa-chevron-left mr-1" aria-hidden="true"></span>Back to Configurations list
      </button>
    </div>
    <div class="col-12 col-lg-8 p-0 d-lg-flex justify-content-lg-end">
      <button id="resetButton" type="button" class="btn btn-secondary w-md-100 mr-2 mt-lg-0 mt-2" (click)="resetToDefault()" [disabled]="isReadOnly">
        <span class="fa fa-undo mr-1" aria-hidden="true"></span>Reset to defaults
      </button>
      <button id="discardButton" type="button" class="col-lg-2 col-md-12 btn btn-danger w-md-100 mr-2 mt-lg-0 mt-2" (click)="discardChanges()" [disabled]="isReadOnly || !hasChanges">
        <span class="fa fa-times mr-1" aria-hidden="true"></span>Discard
      </button>
      <button type="submit" class="col-lg-2 col-md-12 btn btn-primary w-md-100 mt-lg-0 mt-2" [disabled]="isReadOnly || !hasChanges">
        <span class="fa fa-save mr-1" aria-hidden="true"></span>Save
      </button>
    </div>
  </div>
</form>
